import { render, staticRenderFns } from "./EmailSendMgmt.vue?vue&type=template&id=463d5c14&"
import script from "./EmailSendMgmt.vue?vue&type=script&lang=js&"
export * from "./EmailSendMgmt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports